import api from "api/axios"

export interface AuthorizationGrant {
  module: string
  scope_type: string
  scope_id: number
  actions: string[]
}

export interface AuthorizationModule {
  key: string
  enabled: boolean
  actions: string[]
  scope_types: string[]
  unrestricted_within_tenant: boolean
}

export interface AuthorizationScope {
  type: string
  id: number
  label: string
  active: boolean
}

export const getAuthorizationMe = () => api.get("authorization/me/")
export const getAuthorizationCatalog = () => api.get<{ modules: AuthorizationModule[] }>("authorization/catalog/")
export const getAuthorizationScopes = (module: string, search = "") =>
  api.get<{ results: AuthorizationScope[] }>(`authorization/modules/${module}/scopes/`, { params: { search } })
export const getUserGrants = (userId: number) =>
  api.get<{ version: number; grants: AuthorizationGrant[] }>(`authorization/users/${userId}/grants/`)
export const replaceUserGrants = (userId: number, version: number, grants: AuthorizationGrant[]) =>
  api.put(`authorization/users/${userId}/grants/`, { version, grants })

